import { tenantHttp, type HttpClient, type QueryParams } from './core/http-client';
import type {
  ApiKey,
  NewApiKey,
  NewWebhook,
  WebhookDelivery,
  WebhookEndpoint,
  WebhookUpdate,
} from './models';

// API keys and webhooks.
export class IntegrationsService {
  constructor(private readonly http: HttpClient) {}

  apiKeys = () => this.http.get<ApiKey[]>('/business/api-keys');

  createApiKey = (b: NewApiKey) =>
    this.http.post<ApiKey & { key: string }>('/business/api-keys', b);

  revokeApiKey = (id: string) => this.http.delete(`/business/api-keys/${id}`);

  // The WordPress plugin's Connect screen: approve, then the browser goes back to the site.
  approveWordPress = (b: { siteUrl: string; callbackUrl: string; state: string }) =>
    this.http.post<{ redirectUrl: string }>('/business/integrations/wordpress/approve', b);

  webhooks = () => this.http.get<WebhookEndpoint[]>('/business/webhooks');

  webhookEventTypes = () => this.http.get<string[]>('/business/webhooks/event-types');

  createWebhook = (b: NewWebhook) =>
    this.http.post<WebhookEndpoint & { secret: string }>('/business/webhooks', b);

  updateWebhook = (id: string, b: WebhookUpdate) => this.http.patch(`/business/webhooks/${id}`, b);

  deleteWebhook = (id: string) => this.http.delete(`/business/webhooks/${id}`);

  rotateSecret = (id: string) =>
    this.http.post<{ secret: string }>(`/business/webhooks/${id}/rotate-secret`);

  testWebhook = (id: string) => this.http.post(`/business/webhooks/${id}/test`);

  deliveries = (id: string, query: QueryParams) =>
    this.http.getPage<WebhookDelivery>(`/business/webhooks/${id}/deliveries`, { query });

  redeliver = (deliveryId: string) =>
    this.http.post(`/business/webhooks/deliveries/${deliveryId}/redeliver`);
}

export const integrationsService = new IntegrationsService(tenantHttp);
